export default __webpack_public_path__ + "static/media/how-it-works-reviewer.7aaf5e64.svg";